export const downloadCsvFile = (data) => {
  const blob = new Blob([data], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', 'download.csv');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const objectToCsv = (data) => {
  let csv = '';
  let header = Object.keys(data[0]).join(',');
  let values = data.map((o) => Object.values(o).join(',')).join('\n');

  csv += header + '\n' + values;
  return csv;
};

export const processLoanData = (data) => {
  if (data == null) {
    return {};
  }
  return {
    applicationDate:
      data.applicationDate === null
        ? data.applicationDate
        : data.applicationDate[0] +
          '-' +
          data.applicationDate[1] +
          '-' +
          data.applicationDate[2],
    name: data.name,
    surname: data.surname,
    pesel: data.pesel,
    idDocNumber: data.idDocNumber,
    companyName: data.companyName,
    nip: data.nip,
    regon: data.regon,
    loanAmount: data.loanAmount,
    loanType: data.loanType,
    loanLength: data.loanLength,
    phoneNumber: data.phoneNumber,
    email: data.email,
    directPaymentYear: data.directPaymentYear,
    directPaymentIncome: data.directPaymentIncome,
    directPaymentIdentification: data.directPaymentIdentification,
    bigAgreement: data.bigAgreement,
    bigAgreementDate:
      data.bigAgreementDate == null
        ? data.bigAgreementDate
        : data.bigAgreementDate[0] +
          '-' +
          data.bigAgreementDate[1] +
          '-' +
          data.bigAgreementDate[2],
    incomeHighEnough: data.incomeHighEnough,
    solvent: data.solvent,
    bigAgreementNIP: data.bigAgreementNIP,
    bigAgreementNipDate:
      data.bigAgreementNipDate == null
        ? data.bigAgreementNipDate
        : data.bigAgreementNipDate[0] +
          '-' +
          data.bigAgreementNipDate[1] +
          '-' +
          data.bigAgreementNipDate[2],
    dataProcessingPermission: data.dataProcessingPermission,
    dataProcessingPermissionDate:
      data.dataProcessingPermissionDate == null
        ? data.dataProcessingPermissionDate
        : data.dataProcessingPermissionDate[0] +
          '-' +
          data.dataProcessingPermissionDate[1] +
          '-' +
          data.dataProcessingPermissionDate[2],
    bankPermission: data.bankPermission,
    bankPermissionDate:
      data.bankPermissionDate == null
        ? data.bankPermissionDate
        : data.bankPermissionDate[0] +
          '-' +
          data.bankPermissionDate[1] +
          '-' +
          data.bankPermissionDate[2],
    agrowePermission: data.agrowePermission,
    agrowePermissionDate:
      data.agrowePermissionDate == null
        ? data.agrowePermissionDate
        : data.agrowePermissionDate[0] +
          '-' +
          data.agrowePermissionDate[1] +
          '-' +
          data.agrowePermissionDate[2],
    financialLiabilities: data.financialLiabilityList
      .map((u) => u.name)
      .join(',')
      .toString(),
    additionalIncomes: data.additionalIncomeList
      .map((u) => u.name)
      .join(',')
      .toString(),
    animalProduction: data.animalProductionList
      .map((u) => u.name)
      .join(',')
      .toString(),
  };
};
